import { createIcon } from '../createIcon';

export const ShieldAltIconConfig = {
  name: 'ShieldAltIcon',
  height: 512,
  width: 512,
  svgPath: "M466.5 83.7l-192-80a48.15 48.15 0 0 0-36.9 0l-192 80C27.7 91.1 16 108.6 16 128c0 198.5 114.5 335.7 221.5 380.3 11.8 4.9 25.1 4.9 36.9 0C360.1 472.6 496 349.3 496 128c0-19.4-11.7-36.9-29.5-44.3zM256.1 446.3l-.1-381 175.9 73.3c-3.3 151.4-82.1 261.1-175.8 307.7z",
  yOffset: 0,
  xOffset: 0,
  svgClassName: undefined,
};

export const ShieldAltIcon = createIcon(ShieldAltIconConfig);

export default ShieldAltIcon;